import { render, staticRenderFns } from "./OrderBuilded.vue?vue&type=template&id=2144b114&scoped=true&lang=pug&"
import script from "./OrderBuilded.vue?vue&type=script&lang=js&"
export * from "./OrderBuilded.vue?vue&type=script&lang=js&"
import style0 from "./OrderBuilded.vue?vue&type=style&index=0&id=2144b114&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2144b114",
  null
  
)

export default component.exports